import { replaceRichTextReferences } from '../../inputs/rich-text-advanced/render/postprocess-html/replaceRichTextReferences';
import { materializeReference } from '../../schema/expressions/evaluate/materializeReferencePath';
import { formatReferenceValue } from '../../schema/expressions/references/display/formatReferenceValue';
import { IHydrationContext } from '../IHydrationContext';
import { getHydratedReferenceValue } from '../expression/getHydratedReferenceValue';

/**
 * Idrata un testo RTE assumendo di essere nella root
 */
export function hydrateRichTextAsRoot(
  context: IHydrationContext,
  text: string | null | undefined,
) {
  if (!text) return null;
  return replaceRichTextReferences(text, ref => {
    const materializedRef = materializeReference(ref, 'root');
    return formatReferenceValue(
      materializedRef,
      getHydratedReferenceValue(context, materializedRef),
    );
  });
}
